import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-org01",
  "use": "icon-org01-usage",
  "viewBox": "0 0 1325 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1325 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-org01\"><path d=\"M240.941176 542.117647h903.529412v60.235294H240.941176zM361.411765 0h662.588235v421.647059H361.411765zM59.090824 722.823529h301.17647v301.176471h-301.17647zM544.406588 722.823529h301.176471v301.176471h-301.176471zM1021.711059 722.823529h301.17647v301.176471h-301.17647z\" fill=\"#64676f\" /><path d=\"M662.588235 301.176471h60.235294v542.117647h-60.235294zM180.705882 542.117647h60.235294v361.411765H180.705882zM1144.470588 542.117647h60.235294v361.411765h-60.235294z\" fill=\"#64676f\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/org01.svg
// module id = JiKO
// module chunks = 22